import { render, staticRenderFns } from "./beleza.vue?vue&type=template&id=8eb2afe4&scoped=true"
import script from "./beleza.vue?vue&type=script&lang=js"
export * from "./beleza.vue?vue&type=script&lang=js"
import style0 from "./beleza.vue?vue&type=style&index=0&id=8eb2afe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb2afe4",
  null
  
)

export default component.exports